import { MOCK_ITINERARY } from '@/__mock__/itinerary';
import { useItineraryNavigation } from '@/hooks/useItineraryNavigation';
import { useUrl } from '@/hooks/useUrl';

import type { Itinerary } from '@/types/itinerary';

export function useItinerary() {
  // const { itineraryId: decodedId } = useParams();
  //
  // if (!decodedId) {
  //   throw new Error('No itinerary ID provided');
  // }

  const itineraryId = 'test';
  const itinerary = useUrl<Itinerary>({ url: `/proxy/itinerary/${itineraryId}` });
  const itineraryNavigation = useItineraryNavigation();
  return {
    ...itinerary,
    data: MOCK_ITINERARY,
    itineraryId,
    navigation: itineraryNavigation,
  };
}

export type UseItinerary = ReturnType<typeof useItinerary>;
